import React, { useEffect, useRef, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container } from "react-bootstrap";
import "../assets/storeDashboard/dashboard.css";
import { getNextPickupTime, getStoreLocalData, getUserData, setNextPickupTime } from "../utils/localStorage";
import { getStoreNewPick, getStoreOrderDashboard, getStoreOrderDashboardNew } from "../services/DashboardAPI/DashboardApi";
import { formatDate, formatDateNew } from "../constants/DateUtil/DateUtil";
import { useNavigate } from "react-router-dom";
import AddNewCustomer from "./AddNewCustomer/AddNewCustomer";
import StoreMenu from "./StoreMenu";
import TabMenu from "./TabMenu";

import qz from "qz-tray";
import ButtonLink from "../ButtonLink";
import { SubscriptionExpiryAlert } from "./ExpiredSoon";
import { Toast } from "primereact/toast";
import PickupNotification from "../assets/sounds/pickup-notification.mp3"

const { innerWidth: width, innerHeight: height } = window;

const backgroundImages = [
  "/Laundy_App_Icons_Gifs/Home_Page/Delivery.png",
  "/Laundy_App_Icons_Gifs/Home_Page/Pickup.png",
  "/Laundy_App_Icons_Gifs/Home_Page/Today_bookings.png",
  "/Laundy_App_Icons_Gifs/Home_Page/Reprocess.png",
  "/Laundy_App_Icons_Gifs/Home_Page/Rider_delivery.png",
  "/Laundy_App_Icons_Gifs/Home_Page/Pending_orders.png",
  "/Laundy_App_Icons_Gifs/Home_Page/Rider_pickup.png",
  "/Laundy_App_Icons_Gifs/Home_Page/darkGreen.png",
  "/Laundy_App_Icons_Gifs/Home_Page/blue.png",
  "/Laundy_App_Icons_Gifs/Home_Page/brown.png",
  "/Laundy_App_Icons_Gifs/Home_Page/grey.png",
  "/Laundy_App_Icons_Gifs/Home_Page/orange.png",
  "/Laundy_App_Icons_Gifs/Home_Page/pink.png",
  "/Laundy_App_Icons_Gifs/Home_Page/wine.png",
  "/Laundy_App_Icons_Gifs/Home_Page/seaGreen.png",
];

const StoreDashboard = () => {
  const navigate = useNavigate();

  const { userProfileData, storeData,brandProfileData } = getUserData();
  const { storeLocalData } = getStoreLocalData();
  const storeId = storeData.id;
  let brandId = brandProfileData.id;
  const enabledCustomerRevenueDetail = storeData.enabledCustomerRevenueDetail;
  const enabledCustomerRevenueDetailV2 = storeData.enabledCustomerRevenueDetailV2;

  const subscriptionExpiryDate = userProfileData.nextRenewalOn;
  const enabledAmountRoundOff = storeData.enabledAmountRoundOff ? 0 : 2;  


  const enabledAddInternationalCustomer = storeData.enabledAddInternationalCustomer;
  const enabledNewPickupStoreNotified = storeData.enabledNewPickupStoreNotified;
   const toast = useRef(null);
    const audioRef = useRef(null);
    const hasNotifiedRef = useRef(false);

  const base64String = `data:image/png;base64,${storeData.logo}`;
  const [addNewCustomerModalVisible, setAddNewCustomerModalVisible] =
    useState(false);

  const [dashboardData, setDashboardData] = useState([]);
  const [visible, setVisible] = useState(false);

  const fetchStoreOrderDashboard = () => {
    getStoreOrderDashboard(storeId)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          const arrayResult = [
            {
              id: 0,
              name: "BOOKING",
              orderCount: Res["BOOKING"].orderCount,
              revenue: Number(Res["BOOKING"].revenue)?.toFixed(enabledAmountRoundOff),
              storeOrderByStatus: Res["BOOKING"].storeOrderByStatus,
              backgroundImages: backgroundImages[0],
            },
            {
              id: 1,
              name: "REVENUE",
              orderCount: Res["REVENUE"].orderCount,
              revenue: Number(Res["REVENUE"].revenue)?.toFixed(enabledAmountRoundOff),
              storeOrderByStatus: Res["REVENUE"].storeOrderByStatus,
              backgroundImages: backgroundImages[1],
            },
            {
              id: 2,
              name: "CANCEL",
              orderCount: Res["CANCEL"].orderCount,
              revenue: Number(Res["CANCEL"].revenue)?.toFixed(enabledAmountRoundOff),
              storeOrderByStatus: Res["CANCEL"].storeOrderByStatus,
              backgroundImages: backgroundImages[2],
            },
            {
              id: 3,
              name: "DELIVERY",
              orderCount: Res["DELIVERY"].orderCount,
              revenue: Number(Res["DELIVERY"].revenue)?.toFixed(enabledAmountRoundOff),
              storeOrderByStatus: Res["DELIVERY"].storeOrderByStatus,
              backgroundImages: backgroundImages[3],
            },
            {
              id: 4,
              name: "PENDING",
              orderCount: Res["PENDING"].orderCount,
              revenue: Number(Res["PENDING"].revenue)?.toFixed(enabledAmountRoundOff),
              storeOrderByStatus: Res["PENDING"].storeOrderByStatus,
              backgroundImages: backgroundImages[4],
            },
            {
              id: 5,
              name: "PENDING_DELIVERY",
              orderCount: Res["PENDING_DELIVERY"].orderCount,
              revenue: Number(Res["PENDING_DELIVERY"].revenue)?.toFixed(enabledAmountRoundOff),
              storeOrderByStatus: Res["PENDING_DELIVERY"].storeOrderByStatus,
              backgroundImages: backgroundImages[5],
            },
            {
              id: 6,
              name: "RIDER_PICKUP",
              orderCount: Res["RIDER_PICKUP"].orderCount,
              revenue: Number(Res["RIDER_PICKUP"].revenue)?.toFixed(enabledAmountRoundOff),
              storeOrderByStatus: Res["RIDER_PICKUP"].storeOrderByStatus,
              backgroundImages: backgroundImages[6],
            },
            {
              id: 7,
              name: "RIDER_DELIVERY",
              orderCount: Res["RIDER_DELIVERY"].orderCount,
              revenue: Number(Res["RIDER_DELIVERY"].revenue)?.toFixed(enabledAmountRoundOff),
              storeOrderByStatus: Res["RIDER_DELIVERY"].storeOrderByStatus,
              backgroundImages: backgroundImages[11],
            },
            {
              id: 8,
              name: "PAYMENT_COLLECTION",
              orderCount: Res["PAYMENT_COLLECTION"].orderCount,
              revenue: Number(Res["PAYMENT_COLLECTION"].revenue)?.toFixed(enabledAmountRoundOff),
              storeOrderByStatus: Res["PAYMENT_COLLECTION"].storeOrderByStatus,
              backgroundImages: backgroundImages[12],
            },
            {
              id: 9,
              name: "STORE_CUSTOMER_ACCOUNT_PAYMENT_COLLECTION",
              orderCount:
                Res["STORE_CUSTOMER_ACCOUNT_PAYMENT_COLLECTION"].orderCount,
              revenue: Number(Res["STORE_CUSTOMER_ACCOUNT_PAYMENT_COLLECTION"].revenue)?.toFixed(enabledAmountRoundOff),
              storeOrderByStatus:
                Res["STORE_CUSTOMER_ACCOUNT_PAYMENT_COLLECTION"]
                  .storeOrderByStatus,
              backgroundImages: backgroundImages[13],
            },
            ...(Res["REFUND"] && Res["REFUND"].revenue > 0
              ? [
                  {
                    id: 10,
                    name: "REFUND",
                    orderCount: Res["REFUND"].orderCount,
                    revenue: Number(Res["REFUND"].revenue)?.toFixed(enabledAmountRoundOff),
                    storeOrderByStatus: Res["REFUND"].storeOrderByStatus,
                    backgroundImages: backgroundImages[14],
                  },
                ]
              : []),
          ];
          setDashboardData(arrayResult);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const [isConnected, setIsConnected] = useState(false);

  const connectToQZ = async () => {
    try {
      if (!qz.websocket.isActive()) {
        await qz.websocket.connect();
        setIsConnected(true);
      }
    } catch (err) {
      console.error("Connection error:", err);
    }
  };

   const showInfo = (data) => {
       toast.current?.show({
         severity: "info",
         summary: "Notification",
         detail: `You got a ${data > 1 ? data : ""} new pick up request, please check`,
         life: 10000,
       });
   
       // 🔊 Play sound
       if (audioRef.current) {
         audioRef.current.currentTime = 0; // restart sound
         audioRef.current.play().catch(() => {
           // autoplay might be blocked until user interaction
         });
       }
     };
   
    //  useEffect(() => {
    //    const unlockAudio = () => {
    //      if (audioRef.current) {
    //        audioRef.current.play().then(() => {
    //          audioRef.current.pause();
    //          audioRef.current.currentTime = 0;
    //        });
    //      }
    //      document.removeEventListener("click", unlockAudio);
    //    };
   
    //    document.addEventListener("click", unlockAudio);
   
    //    return () => document.removeEventListener("click", unlockAudio);
    //  }, []);
   
     const fetchStoreNewPick = async () => {
       try {
         const response = await getStoreNewPick(storeId);
   
         if (!response.data.error) {
           if (response.data > 0 && !hasNotifiedRef.current) {
             showInfo(response.data);
             hasNotifiedRef.current = true;
           }
   
           // reset when no pickup exists
           if (response.data === 0) {
             hasNotifiedRef.current = false;
           }
         }
       } catch (err) {
         console.error(err);
       }
     };

      useEffect(() => {
         if (enabledNewPickupStoreNotified) {
     
           // Initialize timer if not present
           if (!getNextPickupTime()) {
             setNextPickupTime();
           }
     
           const interval = setInterval(() => {
             const nextTime = getNextPickupTime();
             const now = Date.now();
     
             if (now >= nextTime) {
               // ⏰ Time is zero → call API
               fetchStoreNewPick();
     
               // 🔄 Reset timer
               setNextPickupTime();
             }
           }, 1000); // check every second
     
           return () => clearInterval(interval);
         }
       }, [enabledNewPickupStoreNotified]);
   
    //  useEffect(() => {
    //    const interval = setInterval(() => {
    //      fetchStoreNewPick();
    //    }, 15000); // 15 seconds
   
    //    return () => clearInterval(interval);
    //  }, []);
     

  useEffect(() => {
    // qz.api.setSha256Type(data => window.crypto.subtle.digest("SHA-256", new TextEncoder("utf-8").encode(data)));

    // qz.security.setCertificatePromise(() => {
    //   return fetch("/certs/qz-tray.crt")
    //     .then(res => res.text());
    // });

    // qz.security.setSignaturePromise(toSign => {
    //   return fetch("http://192.168.1.34:3000/sign-message", {
    //     method: "POST",
    //     headers: { "Content-Type": "text/plain" },
    //     body: toSign
    //   }).then(res => res.text());
    // });
    if(!isConnected) 
      {
        connectToQZ();
      }

    fetchStoreOrderDashboard();
  }, []);

  const onSelectCardItem = (id, storeOrderByStatus) => {

    if (id === 1) {
      if (!enabledCustomerRevenueDetailV2) return; // block navigation
      navigate("/DashboardOrder", {
        state: {
          orderFilterData: storeOrderByStatus,
          source: "s2",
        },
      });
      return;
    }

    if (id === 0 || id === 2 || id === 3 || id === 4 || id === 5) {
      navigate("/DashboardOrder", {
        state: {
          orderFilterData: storeOrderByStatus,
          source: "s2",
        },
      });
    } else if (id === 6) {
      navigate("/DashboardPickupJob", {
        state: {
          orderFilterData: storeOrderByStatus,
          source: "s2",
        },
      });
    } else if (id === 7) {
      navigate("/DashboardDeliveryJob", {
        state: {
          orderFilterData: storeOrderByStatus,
          source: "s2",
        },
      });
    } else if (id === 8) {
      navigate("/DashboardPaymentCollection", {
        state: {
          orderFilterData: storeOrderByStatus,
          source: "s2",
        },
      });
    } else if (id === 9) {
      navigate("/WalletCollection", {
        state: {
          orderFilterData: storeOrderByStatus,
          source: "s2",
        },
      });
    } else if (id === 10) {
      navigate("/DashboardPaymentRefund", {
        state: {
          orderFilterData: storeOrderByStatus,
          source: "s2",
        },
      });
    } else {
      navigate("/Home");
    }
  };

  const renderDashboardCards = () => {
    return dashboardData.map((item) => {
      const {
        id,
        name,
        orderCount,
        revenue,
        storeOrderByStatus,
        backgroundImages,
      } = item;

      let convertedName = name;
      let displayOrderCount = orderCount;
      let icon = "";
      let todayDate = "";

      switch (name) {
        case "BOOKING":
          convertedName = "Booking";
          todayDate = formatDateNew(storeOrderByStatus.startDate);
          break;
        case "REVENUE":
          convertedName = "Revenue";
          displayOrderCount = enabledCustomerRevenueDetailV2 ? revenue : "XXXX";
          icon = storeLocalData?.currencySymbol ;
          todayDate = formatDateNew(storeOrderByStatus.startDate);
          break;
        case "CANCEL":
          convertedName = "Cancel";
          todayDate = formatDateNew(storeOrderByStatus.startDate);
          break;
        case "DELIVERY":
          convertedName = "Delivery";
          todayDate = formatDateNew(storeOrderByStatus.startDate);
          break;
        case "PENDING":
          convertedName = "Pending Orders";
          todayDate="Last 7 Days"
          break;
        case "PENDING_DELIVERY":
          convertedName = "Delay Delivery";
          todayDate="Last 7 Days"
          break;
        case "RIDER_PICKUP":
          convertedName = "Rider Pickup";
          todayDate = formatDateNew(storeOrderByStatus.startDate);
          break;
        case "RIDER_DELIVERY":
          convertedName = "Rider Delivery";
          todayDate = formatDateNew(storeOrderByStatus.startDate);
          break;
        case "PAYMENT_COLLECTION":
          convertedName = "Collection";
          displayOrderCount = revenue;
          icon = storeLocalData?.currencySymbol;
          todayDate = formatDateNew(storeOrderByStatus.startDate);
          break;
        case "STORE_CUSTOMER_ACCOUNT_PAYMENT_COLLECTION":
          convertedName = "Wallet Collection";
          displayOrderCount = revenue;
          icon = storeLocalData?.currencySymbol;
          todayDate = formatDateNew(storeOrderByStatus.startDate);
          break;
        case "REFUND":
          convertedName = "Refund";
          displayOrderCount = revenue;
          icon = storeLocalData?.currencySymbol;
          todayDate = formatDateNew(storeOrderByStatus.startDate);
          break;
        default:
          break;
      }

      return (
        <div
          key={name}
          className="relative overflow-hidden"
          onClick={() => onSelectCardItem(id, storeOrderByStatus)}
          style={{ cursor: "pointer" }}
        >
          <img
            className="h-8rem w-11rem"
            src={backgroundImages}
            alt={convertedName}
          />
          <div
            className="absolute py-2 pl-3 border-round-xs"
            style={{
              top: "1%",
            }}
          >
            <p className="text-white text-3xl font-bold uppercase">
              {icon}
              {displayOrderCount}
            </p>
            <p className="text-white text-base font-bold uppercase">
              {convertedName}
            </p>
            {todayDate && (
              <p className="text-white text-base font-bold uppercase">
                {todayDate}
              </p>
            )}
          </div>
        </div>
      );
    });
  };

  return (
    <div className="flex-1">
      <div
        className="h-8rem border-round-bottom surface-0 sticky z-1 top-0"
        style={{
          "--border-radius": "50px",
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex flex-row ml-3 mr-3 pt-2">
          <div className="flex-1 flex flex-row">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div
                className="h-4rem w-4rem border-circle bg-white flex justify-content-center align-items-center cursor-pointer"
                onClick={() => navigate("/UserProfile")}
              >
                {storeData.logo ? (
                  <img
                    style={{ width: "35px" }}
                    src={base64String}
                    alt="logo"
                  />
                ) : (
                  <img
                    style={{ width: "35px" }}
                    src="/warehouse/warehouse_2.png"
                    alt="logo"
                  />
                )}
              </div>
            </div>
            <div className="flex-1 ml-3">
              <p className="text-white text-xl font-bold uppercase">
                {userProfileData.firstName.replace(/_/g, " ")}{" "}
                {userProfileData.lastName.replace(/_/g, " ")}
              </p>
              <p className="text-white text-base font-bold uppercase">
                Manager - {storeData.storeName.replace(/_/g, " ")}
              </p>
              <p className="text-white text-sm font-light">
                <img
                  style={{ width: "10px", marginRight: 5 }}
                  src="/Laundy_App_Icons_Gifs/Home_Page_Menu_Bar/Location.png"
                  alt="logo"
                />
                {storeData.address.fullAddress}
              </p>
            </div>
          </div>
          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "30px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
        <div className="flex-1 flex flex-row">
          <div
            className="flex-1 flex justify-content-start align-items-center relative mt-3 ml-5 h-3rem bg-white border-round-xl shadow-4"
            onClick={() => navigate("/searchCustomer")}
            style={{ cursor: "pointer" }}
          >
            <img
              style={{ width: "20px", marginLeft: 10, marginRight: 10 }}
              src="/Laundy_App_Icons_Gifs/Home_Page_Menu_Bar/Search.png"
              alt="logo"
            />
            <p
              style={{
                color: "#75879B",
                fontSize: 16,
              }}
            >
              Search User By Name, Mobile No., Email & Address{" "}
            </p>
          </div>
          <div
            className="flex justify-content-center align-items-center"
            style={{ flex: 0.1 }}
          >
            <div className="flex justify-content-center align-items-center relative mt-3 h-3rem w-3rem bg-white border-circle shadow-4 align-self-center">
              <img
                style={{ width: "25px", cursor: "pointer" }}
                onClick={(e) => setAddNewCustomerModalVisible(true)}
                src="/Laundy_App_Icons_Gifs/Home_Page_Menu_Bar/Quick_add_customer.png"
                alt="logo"
              />
            </div>
          </div>
        </div>
      </div>
      {enabledCustomerRevenueDetail ? (
        <div className="flex" style={{ marginBottom: 100 }}>
          <div className="px-0 ml-5 mr-5 relative flex-1 mt-5">
            <div className="formgroup-inline gap-4">
              {renderDashboardCards()}
            </div>
          </div>
        </div>
      ) : (
        <div className="flex flex-column" style={{ marginBottom: 100 }}>
          <div className="px-0 ml-5 mr-5 flex-1 mt-5 flex justify-content-center">
            <p className="text-3xl font-bold">No Dashboard To Display</p>
          </div>
          <div className="px-0 ml-5 mr-5 flex-1 mt-2 flex justify-content-center">
            <p className="text-3xl font-bold">
              You Have No Access To View This Dashboard
            </p>
          </div>
        </div>
      )}
      <TabMenu />
      <div>
        <AddNewCustomer
          setAddNewCustomerModalVisible={setAddNewCustomerModalVisible}
          addNewCustomerModalVisible={addNewCustomerModalVisible}
          storeId={storeId}
          brandId={brandId}
          StoreAddress={storeData.address}
          enabledAddInternationalCustomer={enabledAddInternationalCustomer}
        />
        <StoreMenu setVisible={setVisible} visible={visible} />
      </div>
      <SubscriptionExpiryAlert expiryDate={subscriptionExpiryDate} />
       
      <ButtonLink />
      <audio
              ref={audioRef}
              preload="auto"
              // src="https://qdc-static-assets.s3.ap-south-1.amazonaws.com/pickup-notifications/ding.mp3"
              src={PickupNotification}
            />
      <div className="flex justify-content-center">
        <Toast ref={toast} />
      </div>
    </div>
  );
};

export default StoreDashboard;
